import moment from 'moment';

import { ISchedule, IScheduleWorkHours, WeekDays } from '../models';
import { setWholeDaySchedule } from './set-whole-day-schedule';

export function getCurrentScheduleHours(schedule: ISchedule): IScheduleWorkHours[] {
  const scheduleWorkHours: IScheduleWorkHours[] = [];
  const { hours, splitHours } = schedule;
  const dateStr = '1970-01-01';
  const dateStrNextDay = '1970-01-02';
  const dateFmt = 'YYYY-MM-DD HH:mm';

  for (const day in hours) {
    const weekDay = day as WeekDays;
    const scheduleHours = setWholeDaySchedule(hours[day]);
    const {
      closed,
      hoursFirstValueFirstArray,
      hoursFirstValueSecondArray,
      hoursSecondValueFirstArray,
      hoursSecondValueSecondArray,
      nextDay,
    } = scheduleHours;

    if (closed) {
      scheduleWorkHours.push({ day: weekDay, closed });
    } else {
      const isNotStringType = typeof hoursFirstValueSecondArray !== 'string' || typeof hoursSecondValueSecondArray !== 'string';
      const hasTwoRanges = isNotStringType && splitHours;
      const nextDayForBaseRange = nextDay && !hasTwoRanges;
      const res = {
        day: weekDay,
        closed,
        baseRange: {
          from: moment.utc(`${dateStr} ${hoursFirstValueFirstArray.hours}:${hoursFirstValueFirstArray.minutes}`, dateFmt).valueOf(),
          to: moment.utc(`${nextDayForBaseRange ? dateStrNextDay : dateStr} ${hoursSecondValueFirstArray.hours}:${hoursSecondValueFirstArray.minutes}`, dateFmt).valueOf(),
        },
      };

      if (hasTwoRanges) {
        Object.assign(res, {
          additionalRange: {
            from: moment.utc(`${dateStr} ${hoursFirstValueSecondArray.hours}:${hoursFirstValueSecondArray.minutes}`, dateFmt).valueOf(),
            to: moment.utc(`${nextDay ? dateStrNextDay : dateStr} ${hoursSecondValueSecondArray.hours}:${hoursSecondValueSecondArray.minutes}`, dateFmt).valueOf(),
          },
        });
      }
      scheduleWorkHours.push(res);
    }
  }

  return scheduleWorkHours;
}
